import $ from 'jquery'

$('.js-quantity-selector button').on('click', function () {
  const up = $(this).hasClass('quantity-selector-up')
  const input = $(this).parent().find('input')
  const current = Number(input.val())

  if (up) {
    input.val(current + 1)
  } else if (current > 1) {
    input.val(current - 1)
  }
})
